import { createRoute, useNavigate } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { FieldsPage } from '../../FieldsPage'
import { editorSearchSchema } from '../search-schemas'

// /fields — список + редактор. Открытие редактора через search-параметры
// (?edit=N или ?new=1), не отдельные роуты — чтобы не размонтировать список
// (resource items, filterText) при переключении list↔editor.
// new имеет приоритет над edit (если оба заданы — открываем форму создания).
export const fieldsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/fields',
  validateSearch: editorSearchSchema,
  component: FieldsRouteComponent,
})

function FieldsRouteComponent() {
  const search = fieldsRoute.useSearch()
  const navigate = useNavigate()
  return (
    <FieldsPage
      fieldId={search().edit ?? null}
      create={search().new === 1}
      onOpen={(id) => navigate({ to: '/fields', search: { edit: id } })}
      onCreate={() => navigate({ to: '/fields', search: { new: 1 } })}
      onBack={() => navigate({ to: '/fields', search: {} })}
    />
  )
}
